(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Mito", [], factory);
	else if(typeof exports === 'object')
		exports["Mito"] = factory();
	else
		root["Mito"] = factory();
})(self, () => {
return 